import { errorValidation, maskList, geoIpLookup } from './utils';

let cabinetPhone = $('#cabinet_phone');
let country_code = $('form[name="cabinet"]').data('country_code');

if (cabinetPhone.length) {
	$(window).on('load', function () {
		let phones_exist = false;
		[cabinetPhone].forEach(phoneInput => {
			var phoneValue = phoneInput.val();
			if (phoneValue) {
				phones_exist = true;
				setTimeout(function () {
					phoneInput.val(phoneValue);
				}, 500);
			}
		});

		if (!phones_exist) {
			setTimeout(function () {
				// geoIpLookup(countryCode => {
				// 	[cabinetPhone].forEach(phoneInput => {
				// 		phoneInput.intlTelInput('setCountry', countryCode.toLowerCase());
				// 		const maskObj = maskList.find(mask => {
				// 			return (
				// 				mask.cc &&
				// 				typeof mask.cc === 'string' &&
				// 				mask.cc.toLowerCase() === countryCode.toLowerCase()
				// 			);
				// 		});
				// 		if (maskObj) {
				// 			console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
				// 			phoneInput.inputmask('remove');
				// 			phoneInput.inputmask({ mask: maskObj.mask });
				// 		}
				// 	});
				// });
			}, 500);
		}
	});
}

/**
 * Init intlTelInput
 */
[cabinetPhone].forEach(phoneInput => {
	phoneInput.intlTelInput({
		initialCountry: 'auto', // Automatically detect the country
		placeholderNumberType: 'aggressive',
		utilsScript:
			'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js',
		separateDialCode: false,
		allowDropdown: false,
	});

	phoneInput.inputmasks({
		inputmask: {
			definitions: {
				'#': {
					validator: '[0-9]',
					cardinality: 1,
				},
			},
			//clearIncomplete: false,
			showMaskOnHover: false, // Show mask
			autoUnmask: true, // Remove country code when input is empty
		},
		match: /[0-9]/,
		replace: '#',
		list: maskList,
		listKey: 'mask',
		onMaskChange: function (maskObj, completed) {
			if (maskObj) {
				// console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
				// let countryCode = Array.isArray(maskObj.cc)
				// 	? maskObj.cc[0].toLowerCase()
				// 	: maskObj.cc.toLowerCase();
				// phoneInput.intlTelInput('setCountry', countryCode);
				phoneInput.intlTelInput('setCountry', country_code.toLowerCase());
			} else {
				console.log(`No mask found, applying default mask`);
				phoneInput.inputmask({ mask: '9999999999' }); // Fallback mask
			}
		},
	});

	// On blur: validate phone number
	phoneInput.focusout(function () {
		if ($.trim(phoneInput.val())) {
			if (phoneInput.intlTelInput('isValidNumber')) {
				console.log('isValidNumber');
			} else {
				phoneInput.addClass('_error');
			}
		}
	});

	// On keydown: reset
	phoneInput.keydown(function () {
		phoneInput.removeClass('_error');
	});
});

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateCabinetPhone',
	function (value, element) {
		return $(element).intlTelInput('isValidNumber');
	},
	window.translations.phoneInvalid
);

/**
 * Validate forms
 */
(() => {
	// Cabinet
	$("form[name='cabinet']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'cabinet[name]': {
				required: true,
			},
			'cabinet[surname]': {
				required: true,
			},
			'cabinet[email]': {
				required: true,
				email: true,
			},
			'cabinet[phone]': {
				required: true,
				validateCabinetPhone: true,
			},
			'register[company]': {
				required: true,
			},
			'register[legal_address]': {
				required: true,
			},
			'register[tax_code]': {
				required: true,
			},
			'register[bank]': {
				required: true,
			},
		},
		messages: {
			'cabinet[name]': {
				required: window.translations.required,
			},
			'cabinet[surname]': {
				required: window.translations.required,
			},
			'cabinet[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'cabinet[phone]': {
				required: window.translations.required,
			},
			'register[company]': {
				required: window.translations.required,
			},
			'register[legal_address]': {
				required: window.translations.required,
			},
			'register[tax_code]': {
				required: window.translations.required,
			},
			'register[bank]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});

	// Cabinet reset
	$("form[name='cabinet_reset']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'cabinet_reset[current_password]': {
				required: true,
			},
			'cabinet_reset[password]': {
				required: true,
			},
			'cabinet_reset[confirm_password]': {
				required: true,
				equalTo: '#password',
			},
		},
		messages: {
			'cabinet_reset[current_password]': {
				required: window.translations.required,
			},
			'cabinet_reset[password]': {
				required: window.translations.required,
			},
			'cabinet_reset[confirm_password]': {
				required: window.translations.required,
				equalTo: window.translations.equalTo,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
